import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import './Footer.css';

const footerLinks = {
  '安全服务': [
    { name: '安全运营服务', path: '/services/security-ops' },
    { name: '渗透测试服务', path: '/services/pen-test' },
    { name: '应急响应服务', path: '/services/emergency-response' },
    { name: '漏洞扫描服务', path: '/services/vuln-scan' },
    { name: '代码审计服务', path: '/services/code-audit' },
    { name: '资产测绘服务', path: '/services/asset-mapping' },
  ],
  '公司': [
    { name: '关于我们', path: '/about' },
    { name: '联系我们', path: '/contact' },
  ],
  '合作伙伴': [
    { name: '山石网科', path: 'https://www.hillstonenet.com.cn', external: true },
    { name: '青藤云安全', path: 'https://www.qingteng.cn', external: true },
    { name: '微步在线', path: 'https://www.threatbook.cn', external: true },
    { name: '阿里云', path: 'https://www.aliyun.com', external: true },
    { name: '绿盟科技', path: 'https://www.nsfocus.com.cn', external: true },
  ],
};

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__top-inner">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={process.env.PUBLIC_URL + '/logo.png'} alt="卓迈科技" className="footer__logo-img" />
              <div>
                <div className="footer__logo-name">卓迈科技</div>
              </div>
            </div>
            <p className="footer__tagline">
              吉林卓迈科技有限公司<br />
              专注网络安全运营、威胁防御与情报服务
            </p>
            <div className="footer__contacts">
              <a href="tel:400xxxxxxxx" className="footer__contact-item">
                <Phone size={13} />
                400-xxx-xxxx
              </a>
              <a href="mailto:service@zzme.net" className="footer__contact-item">
                <Mail size={13} />
                service@zzme.net
              </a>
              <span className="footer__contact-item">
                <MapPin size={13} />
                吉林省长春市高新区中展万国城A10
              </span>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="footer__col">
              <h4 className="footer__col-title">{title}</h4>
              <ul className="footer__col-links">
                {links.map((link) => (
                  <li key={link.name}>
                    {link.external ? (
                      <a href={link.path} target="_blank" rel="noopener noreferrer" className="footer__link">
                        {link.name}
                        <ExternalLink size={10} />
                      </a>
                    ) : (
                      <Link to={link.path} className="footer__link">
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <span>© {year} 吉林卓迈科技有限公司 版权所有</span>
          <div className="footer__records">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="footer__icp">
              吉ICP备2026000121号-1
            </a>
            <span className="footer__divider">|</span>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank" rel="noopener noreferrer" className="footer__icp footer__gongan">
              <img src="https://img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png" alt="公安网备" className="gongan-icon" />
              吉公网安备 XXXXXXXXXXXXXX号
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
